var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlowdry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E1E3E3;}\n\t.st4{fill:#FFD1D1;}\n\t.st5{fill:none;}\n\t.st6{fill:#0A1514;}\n\t.st7{fill:#C0C3C3;}\n\t.st8{fill:#821bb8;}\n\t.st9{fill:#677371;}\n\t.st10{fill:none;stroke:#677371;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#F8D1CF;}\n\t.st12{fill:#EE8B88;}\n\t.st13{display:inline;fill:#C0C3C3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -384,
    y: -1757,
    className: "st2",
    width: 800,
    height: 3706
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "main"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11,24.8l-1.3-5.4h-3L8,24.8c0.4,1.6-0.4,3.1-1.8,3.8c0.5,0.2,1,0.4,1.5,0.4C9.9,29,11.5,27,11,24.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.9,2.6c-1-0.2-2-0.1-2.9,0L22,5v12L8,19.3c0.9,0.2,1.9,0.2,2.9,0L25,17V5L10.9,2.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M4,11c0,2.8,2.2,5,5,5s5-2.2,5-5s-2.2-5-5-5S4,8.2,4,11z M12,11c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3 S12,9.3,12,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M25.2,4L11,1.7C8.3,1.2,5.5,2,3.3,3.8C1.2,5.6,0,8.2,0,11c0,1.5,0.4,3,1,4.3l2.4,11.2c0.4,2,2.2,3.5,4.3,3.5 c1.3,0,2.6-0.6,3.4-1.7c0.8-1.1,1.1-2.4,0.8-3.7l-1-4.3c0,0,0,0,0,0L25.2,18c0.5-0.1,0.8-0.5,0.8-1V5C26,4.5,25.6,4.1,25.2,4z  M9.6,27.1C9.1,27.7,8.5,28,7.7,28c-1.1,0-2.1-0.8-2.3-1.9l-1.6-7.6c1.5,1.1,3.3,1.8,5.2,1.9l1.1,4.6 C10.2,25.8,10.1,26.5,9.6,27.1z M18.8,17l-8.1,1.4c-2.2,0.4-4.4-0.2-6.1-1.7C3,15.3,2,13.2,2,11s1-4.3,2.6-5.7 C6,4.1,7.7,3.5,9.5,3.5c0.4,0,0.8,0,1.2,0.1L18.8,5V17z M24,16.2l-3.2,0.5V5.3L24,5.8V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M29,8h2c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2c-0.6,0-1,0.4-1,1S28.4,8,29,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31,10h-2c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1S31.6,10,31,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31,14h-2c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1S31.6,14,31,14z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cm",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    width: 32,
    height: 32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlowdry);
export default __webpack_public_path__ + "static/media/blowdry.9b78d908401ffbcf1f76bfdfbffd1938.svg";
export { ForwardRef as ReactComponent };